import { constants } from '@wsb/guac-widget-core';
import { COMMON_BUTTON_CONFIG } from '../../common/constants';
import { FILL, WIDE_INSET, FLEX_FILL } from '../../common/constants/headerTreatments';
import imageToHeaderTreatments from '../../common/utils/imageToHeaderTreatments';
import { IMAGE, VIDEO, NONE } from '../../common/constants/mediaTypes';

const {
  colorPackCategories: { NEUTRAL, ACCENT },
  buttons,
  contentPositions: { CENTER }
} = constants;
const { LIGHT, LIGHT_ALT, LIGHT_COLORFUL, DARK, DARK_ALT, DARK_COLORFUL, COLORFUL } =
  constants.paintJobs;

const id = 'layout30';
const imageTreatments = {
  [FILL]: 'category-overlay',
  [WIDE_INSET]: 'category-solid',
  [FLEX_FILL]: 'category-overlay'
};
const defaultHeaderTreatment = FILL;
const headerTreatments = imageToHeaderTreatments(imageTreatments);
const headerTreatmentsConfig = {
  defaultHeaderTreatment,
  imageTreatments,
  heroContentItems: ['tagline', 'tagline2', 'cta'],
  nonHeroContentItems: ['phone'],
  headerTreatments,
  defaultProps: {
    [FLEX_FILL]: {
      fullWidthMedia: false,
      hasNavWithBackground: false,
      roundedCorners: true,
      category: NEUTRAL,
      contentPosition: CENTER,
      alignment: 'center'
    }
  },
  mediaSupport: {
    [NONE]: [defaultHeaderTreatment],
    [IMAGE]: Object.keys(imageTreatments),
    [VIDEO]: [defaultHeaderTreatment, FLEX_FILL]
  }
};
const defaultPaintJob = LIGHT;

export default {
  id,
  name: 'focus',
  packs: {
    color: '#691c26',
    font: 'league-spartan'
  },
  logo: {
    font: 'primary'
  },
  packCategories: {
    color: ACCENT
  },
  headerProperties: {
    alignmentOption: 'left',
    defaultLogoAlign: 'center'
  },
  paintJobs: [LIGHT, LIGHT_ALT, LIGHT_COLORFUL, COLORFUL, DARK_COLORFUL, DARK_ALT, DARK],
  defaultPaintJob,
  headerTreatmentsConfig,
  buttons: {
    primary: {
      fill: buttons.fills.SOLID,
      shape: buttons.shapes.SQUARE,
      decoration: buttons.decorations.NONE,
      shadow: buttons.shadows.NONE,
      color: buttons.colors.PRIMARY
    },
    secondary: {
      fill: buttons.fills.OPEN,
      decoration: buttons.decorations.UNDERLINE,
      shadow: buttons.shadows.NONE,
      color: buttons.colors.PRIMARY
    },
    ...COMMON_BUTTON_CONFIG
  },
  defaultNavFamily: 'navFamily5'
};
